document.addEventListener("DOMContentLoaded", function () {
  const popup = document.getElementById("klaviyo-bis-popup");
  const overlay = document.getElementById("klaviyo-bis-overlay");
  const form = document.getElementById("klaviyo-bis-form");
  const confirmation = document.getElementById("klaviyo-bis-confirmation");
  const emailInput = document.getElementById("klaviyo-bis-email");

  // Öffnen des Pop-ups
  document.querySelectorAll(".open-bis-modal").forEach(function (btn) {
    btn.addEventListener("click", function () {
      const productTitle = btn.dataset.productTitle || "";
      const productId = btn.dataset.productId || "";
      const productImage = btn.dataset.productImage || "";

      if (popup) {
        // Setze Inhalte im Pop-up
        popup.querySelector(".popup-product-title").textContent = productTitle;
        popup.querySelector("#klaviyo-bis-variant-id").value = productId;
        popup.querySelector("#klaviyo-bis-product").value = productTitle;
        popup.querySelector("#klaviyo-bis-product-image").src = productImage;

        // Zeige Pop-up + Overlay
        popup.style.display = "block";
        overlay.style.display = "block";

        // Reset UI
        form.style.display = "flex";
        confirmation.style.display = "none";
        emailInput.value = "";
      }
    });
  });

  // Schließen über X
  document.getElementById("klaviyo-bis-close")?.addEventListener("click", function () {
    popup.style.display = "none";
    overlay.style.display = "none";
  });

  // Schließen bei Klick außerhalb (Overlay)
  overlay?.addEventListener("click", function () {
    popup.style.display = "none";
    overlay.style.display = "none";
  });
});

//Datenübermittlung Warteliste an Klaviyo
document.addEventListener("DOMContentLoaded", function () {
  console.log("Wartelisten Skript geladen");
  const form = document.getElementById("klaviyo-bis-form");
  const emailInput = document.getElementById("klaviyo-bis-email");
  const variantInput = document.getElementById("klaviyo-bis-variant-id"); // Hidden input mit Variant-ID
  const confirmation = document.getElementById("klaviyo-bis-confirmation");

  if (!form || !emailInput || !variantInput) {
    console.warn("Back-in-Stock-Formular oder Felder fehlen.");
    return;
  }

  form.addEventListener("submit", function (e) {
    e.preventDefault();

    const email = emailInput.value.trim();
    const variantId = document.getElementById("klaviyo-bis-variant-id")?.value;

    if (!email || !variantId) {
      console.error("E-Mail oder Variant-ID fehlt.");
      return;
    }

    const payload = {
      data: {
        type: "back-in-stock-subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: email,
              },
            },
          },
          channels: ["EMAIL"],
        },
        relationships: {
          variant: {
            data: {
              type: "catalog-variant",
              id: `$shopify:::$default:::${variantId}`,
            },
          },
        },
      },
    };

    console.log("PAYLOAD", JSON.stringify(payload, null, 2));
    console.log("🚀 Sende an: https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=WbeXJ7");
    fetch(
      "https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=WbeXJ7",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          revision: "2024-06-15",
          "x-klaviyo-onsite": "1",
        },
        body: JSON.stringify(payload),
      }
    )
      .then((response) => {
        if (response.ok) {
          confirmation.textContent =
            "Danke! Wir benachrichtigen dich, sobald das Produkt wieder verfügbar ist.";
          confirmation.style.color = "green";
          form.style.display = "none";
          confirmation.style.display = "block";
        } else {
          console.error("Klaviyo-Antwortfehler:", response.status);
          confirmation.textContent =
            "Es gab einen Fehler bei der Anmeldung. Bitte versuche es später noch einmal.";
          confirmation.style.color = "red";
          confirmation.style.display = "block";
        }
      })
      .catch((error) => {
        console.error("Fetch-Fehler:", error);
      });
  });
});
